.wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 20px 20px;
}

.lead {
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.reasons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.reason {
  padding: 10px 14px;
  border-radius: var(--r-full);
  background: var(--surface-2);
  border: 1px solid var(--border);
  font-size: var(--fs-sm);
  font-weight: 600;
  transition: all var(--t-fast);
}

.selected {
  background: var(--accent-soft);
  border-color: var(--accent);
  color: var(--accent);
}
